module.exports = __webpack_public_path__ + "img/Process2.261a6f32.svg";